import { Component, Directive, ElementRef, Injector, Input, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { UpgradeComponent } from "@angular/upgrade/static";

@Directive({
    selector: 'email-types-directive',
    standalone: false,
})
export class EmailTypesDirective extends UpgradeComponent {
    constructor(elementRef: ElementRef, injector: Injector) {
        super('emailTypesComponent', elementRef, injector);
    }
}

@Component({
    selector: 'email-types',
    template: '<email-types-directive></email-types-directive>',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EmailTypesComponent {

    constructor() {
        console.log("EmailTypesComponent");

    }
};

@Directive({
    selector: 'email-type-directive',
    standalone: false,
})
export class EmailTypeDirective extends UpgradeComponent {
    @Input() emailTypeId: string;

    constructor(elementRef: ElementRef, injector: Injector) {
        super('emailTypeComponent', elementRef, injector);
    }
}

@Component({
    selector: 'email-type',
    template: '<email-type-directive [emailTypeId]="this.emailTypeId"></email-type-directive>',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EmailTypeComponent {
    @Input() emailTypeId: string;
}

@Directive({
    selector: 'email-logs-directive',
    standalone: false,
})
export class EmailLogsDirective extends UpgradeComponent {
    @Input() defaultFilter: any;

    constructor(elementRef: ElementRef, injector: Injector) {
        super('emailLogsComponent', elementRef, injector);
    }
}

@Component({
    selector: 'email-logs',
    template: '<email-logs-directive [defaultFilter]="defaultFilter"></email-logs-directive>',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EmailLogsComponent implements OnInit {
    defaultFilter: any;

    constructor(private route: ActivatedRoute) {}

    ngOnInit() {
        // Get the email type ID from the route if available
        this.route.params.subscribe(params => {
            if (params['emailTypeId']) {
                this.defaultFilter = {
                    email_type: [params['emailTypeId']]
                };
            } else {
                // Check if we're on the booking logs route
                if (this.route.snapshot.routeConfig && this.route.snapshot.routeConfig.path === 'log_booking') {
                    this.defaultFilter = {
                        block: ['payments', 'bookings']
                    };
                } else {
                    this.defaultFilter = {
                        block: ['users', 'events', 'goals']
                    };
                }
            }
        });
    }
}

@Directive({
    selector: 'email-template-directive',
    standalone: false,
})
export class EmailTemplateDirective extends UpgradeComponent {
    @Input() emailTypeId: string;
    @Input() emailTemplateId: string;
    @Input() duplicateFrom: string;

    constructor(elementRef: ElementRef, injector: Injector) {
        super('emailTemplateComponent', elementRef, injector);
    }
}

@Component({
    selector: 'email-template',
    template: '<email-template-directive [emailTypeId]="emailTypeId" [emailTemplateId]="emailTemplateId" [duplicateFrom]="duplicateFrom"></email-template-directive>',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EmailTemplateComponent {
    @Input() emailTypeId: string;
    @Input() emailTemplateId: string;
    @Input() duplicateFrom: string;
}